exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:Open Sans;src:url(\"/fonts/opensans/OpenSans-Regular.ttf\") format(\"ttf\")}@font-face{font-family:Open Sans;src:url(\"/fonts/opensans/OpenSans-Bold.ttf\") format(\"ttf\");font-weight:700}@font-face{font-family:Open Sans;src:url(\"/fonts/opensans/OpenSans-Semibold.ttf\") format(\"ttf\");font-weight:600}@font-face{font-family:Open Sans;src:url(\"/fonts/opensans/OpenSans-Light.ttf\") format(\"ttf\");font-weight:100}.error{color:#f04953}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js?outputStyle=expanded&includePaths[]=%2FUsers%2Fnickvanmeter%2FSites%2Fmrtn%2Fnode_modules!./src/elements/Error/styles.scss
// module id = 453
// module chunks = 0